<template>
    <b-modal
        id="ModalCreateInstallation"
        title="Créer une installation"
        size="xl"
        header-bg-variant="kalkin-1"
        header-text-variant="light"
        hide-footer
    >
        <FormInstallation
            :project-id="projectId"
            @saved="onSaved"
            class="mb-2"
        />
    </b-modal>
</template>
<script>
import FormInstallation from "@/components/model/installation/FormInstallation";
export default {
    components: {
        FormInstallation,
    },

    props: {
        projectId: { type: [String, Number], required: true },
    },

    methods: {
        onSaved() {
            this.$bvModal.hide("ModalCreateInstallation");
            this.$emit("saved");
        },
    },
};
</script>
